import React, { useEffect, useState } from 'react';
import { PanelForm } from './PanelForm';
import { Plus, SquarePen, Trash2 } from 'lucide-react';
import Pagination from '../../../utils/pagination/Pagination';
import { pageData } from '../../../utils/paginationConfig.js';
import { toast } from 'react-toastify';
import { getPanel } from '../../../redux/reduxApi/panelReduxAPi';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  ModalFooter,
  Spinner,
} from '@chakra-ui/react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { useSelector, useDispatch } from 'react-redux';
import { deletePanel } from '../../../redux/api/panelApi/panelApi.js';
import { deletePanelAction } from '../../../redux/reduxSlice/PanelSlice.js';

export default function PanelList() {
  const [isPanel, setIsPanel] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const [panelData, setPanelData] = useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [panelId, setPanelId] = useState("");
  const [dataToEdit, setDataToEdit] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const getPanelData = useSelector((state) => state.panel.panel);
  const [itemsPerPage, setItemsPerPage] = useState(30);

  const dispatch = useDispatch();

  //for display the data
  useEffect(() => {
    if (getPanelData && getPanelData.length > 0) {
      setPanelData(getPanelData);
    }
  }, [getPanelData]);

  useEffect(() => {
    const page = 1;
    dispatch(getPanel(page)).then((response) => {
      setLoading(false);
    }).catch((error) => {
      console.log(error)
    }).finally(() => {
      setLoading(false)
      setTimeout(() => {
      }, [300])
    })
  }, [])

  // For Trash modal
  const openTrash = () => {
    setIsOpen(true);
  };

  const closeTrash = () => {
    setIsOpen(false);
  };

  const openPanelDrawer = () => {
    setIsPanel(true);
  };

  const closePanel = () => {
    setIsPanel(false);
  };

  // Single Delete
  const handleSingleDelete = (id) => {
    openTrash();
    setDeleteId(id);
    setSelectedRows([id]); // Set as selected for consistency
  };

  // Bulk Delete
  const handleBulkDelete = () => {
    if (selectedRows.length === 0) {
      toast.warning("Please select at least one panel to delete");
      return;
    }
    openTrash();
  };


    const handleDelete = () => {
      setShowProgressBar(true);
      setLoading(true);
      const idsToDelete = selectedRows.length === 0 ? [deleteId] : selectedRows;
      Promise.all(idsToDelete.map((id) => deletePanel(id)))
        .then(() => {
          setPanelData((prevData) => prevData.filter((item) => !idsToDelete.includes(item.ROWID)));
          dispatch(deletePanelAction(idsToDelete));
          toast.success("Row Deleted successfully");
        })
        .catch((error) => {
          console.log(error);
          toast.error("Row not deleted");
        })
        .finally(() => {
          setShowProgressBar(false);
          setLoading(false);
          closeTrash();
          setSelectedRows([]);
          setDeleteId("");
        });
    };

  // Single Select
  const handleRowSelect = (ROWID) => {
    const isSelected = selectedRows.includes(ROWID);
    let newSelectedRows = [];
    if (!isSelected) {
      newSelectedRows = [...selectedRows, ROWID];
    } else {
      newSelectedRows = selectedRows.filter(rowPanel => rowPanel !== ROWID);
    }
    setSelectedRows(newSelectedRows);
  };

  // All Select
  // const handleSelectAllRows = () => {
  //   const currentPageData = panelData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  //   const allSelected = selectedRows.length === currentPageData.length;
    
  //   let newSelectedRows = [];
  //   if (!allSelected) {
  //     newSelectedRows = currentPageData.map(item => item?.ROWID);
  //   }
  //   setSelectedRows(newSelectedRows);
  // };

    const handleSelectAllRows = () => {
    const allSelected = selectedRows.length === panelData.length;
    let newSelectedRows = [];
    if (!allSelected) {
      newSelectedRows = panelData.map((item) => item?.ROWID);
    }
    setSelectedRows(newSelectedRows);
  };

  // Check if all rows on current page are selected
  const isAllSelected = () => {
    const currentPageData = panelData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    return currentPageData.length > 0 && selectedRows.length === currentPageData.length;
  };

  return (
    <>
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="purple.500" />
        </div>
      )}
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {selectedRows.length > 1 ? 'Delete Multiple Panels' : 'Delete Panel'}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {selectedRows.length > 1 
              ? `Are you sure you want to delete ${selectedRows.length} selected panels?`
              : 'Are you sure you want to delete this panel?'
            }
          </ModalBody>
          <ModalFooter>
            <Button className='create-button' mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className='cancel-button' onClick={closeTrash}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      
      <div className="d-flex justify-content-between align-items-center">
        {selectedRows.length > 0 && (
          <div className="ms-2">
            <button 
              className="delete-button mx-2" 
              onClick={handleBulkDelete}
              style={{
                backgroundColor: '#ff176b',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Delete Selected ({selectedRows.length})
            </button>
          </div>
        )}
        <div className="d-flex justify-content-end ms-auto">
          <button className="new-button mx-2" onClick={openPanelDrawer}>
            <Plus size="18px" />
            <span className="ms-1">New</span>
          </button>
        </div>
      </div>

      <div className="custom-scroll leadListConatainer" style={{ maxHeight: "75vh", backgroundColor: '#F3F3F3' }}>
        <TableContainer className='card card-detail mt-1'>
          <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="download-table-xls-button d-none"
            table="table-to-xls"
            filename="Lead List"
            sheet="tablexls"
            buttonText="Export"
          />
          <Table id="table-to-xls" className='leadNoPadding' variant='simple' size='sm' stickyHeader style={{ whiteSpace: 'nowrap', backgroundColor: 'white' }}>
            <Thead>
              <Tr className="tr-border">
                <Th className='py-1 th-color' style={{ width: '50px' }}>
                  <Checkbox 
                    isChecked={isAllSelected()} 
                    onChange={handleSelectAllRows} 
                  />
                </Th>
                <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Actions</Th>
                <Th className='py-1 th-color' style={{ width: '150px' }}>Panel Name</Th>
                <Th className='py-1 th-color' style={{ width: '150px' }}>Panel Description</Th>
                <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Created Time</Th>
                <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Modified Time</Th>
                <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Created By</Th>
              </Tr>
            </Thead>
            <Tbody>
              {panelData && panelData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((item, idx) => (
                <Tr className='tr-border' key={idx}>
                  <Td className='font-colors py-1'>
                    <Checkbox 
                      isChecked={selectedRows.includes(item.ROWID)} 
                      onChange={() => handleRowSelect(item.ROWID)} 
                    />
                  </Td>
                  <Td className='d-flex' style={{ borderBottom: 'none' }}>
                    <SquarePen 
                      color="#ff176b" 
                      size="16px" 
                      strokeWidth="1" 
                      className='mx-1' 
                      onClick={() => { 
                        openPanelDrawer(); 
                        setDataToEdit(item); 
                        setIsUpdateMode(true); 
                        setPanelId(item?.ROWID); 
                      }} 
                      style={{ cursor: 'pointer' }}
                    />
                    <Trash2 
                      color="#ff176b" 
                      size="16px" 
                      strokeWidth="1" 
                      onClick={() => handleSingleDelete(item?.ROWID)} 
                      style={{ cursor: 'pointer' }}
                    />
                  </Td>
                  <Td className='font-colors py-1'>{item?.panelName}</Td>
                  <Td className='font-colors py-1'>{item?.panelDescription}</Td>
                  <Td className='font-colors py-1'>{item?.CREATEDTIME}</Td>
                  <Td className='font-colors py-1'>{item?.MODIFIEDTIME}</Td>
                  <Td className='font-colors py-1'>{item?.createdBy || '-'}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </div>
      <div className="footer d-flex fixed-bottom start-20">
        <div className="total" style={{ marginLeft: "20%", marginTop: "15px" }}>
          <p className="fw-semibold">Total Count: {panelData.length}</p>
          {/* {selectedRows.length > 0 && (
            <p className="fw-semibold text-danger">Selected: {selectedRows.length}</p>
          )} */}
        </div>
        {/* Pagination */}
        <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto">
           <Pagination
              totalPages={Math.ceil(panelData.length / itemsPerPage)}
              onPageChange={(no) => {
                setCurrentPage(no);
                setSelectedRows([]); // Clear selection on page change
              }}
            />
        </div>
      </div>
      <PanelForm
        isPanel={isPanel}
        closePanel={closePanel}
        dataToEdit={dataToEdit}
        isUpdateMode={isUpdateMode}
        setIsUpdateMode={setIsUpdateMode}
        panelId={panelId}
      />
    </>
  );
}